import { Box, Grid, Typography } from "@mui/material";

import OrderSummaryChart from "./OrderSummaryChart";
import LowQuantityStock from "./LowQuantityStock";

import { useLocation, useNavigate } from "react-router-dom";
import OrderCounts from "../../Delivery/Orders/OrderCounts";

export default function Dashboard() {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if '/static' is part of the pathname
  const shouldShowStaticComponent = location.pathname.includes("/static");

  const handleCardClick = (event, tabValue) => {
    navigate("/delivery/orders/todays", { state: { activeTab: tabValue } });
  };

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Today's Jobs
          </Typography>
          <OrderCounts isToday onCardClick={handleCardClick} />
        </Grid>
      </Grid>
      {shouldShowStaticComponent && (
        <Grid container spacing={3} sx={{ mb: 3 }} alignItems="stretch">
          <OrderSummaryChart />
          <LowQuantityStock />
        </Grid>
      )}
    </Box>
  );
}
